import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

export interface ProfileMunicipality {
  title: string;
}

const sellerProfilesMunicipalitiesAdapter = createEntityAdapter<JSONApiDataObject<ProfileMunicipality>>({
  selectId: item => item.id
});

export const sellerProfilesMunicipalitiesSlice = createSlice({
  name: 'sellerProfilesMunicipalities',
  initialState: sellerProfilesMunicipalitiesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<ProfileMunicipality>>),
  reducers: {
    sellerProfilesMunicipalitiesAdded: (state, action) => {
      sellerProfilesMunicipalitiesAdapter.setMany(state, action.payload);
    }
  }
});

export const sellerProfilesMunicipalitiesSelectors = sellerProfilesMunicipalitiesAdapter.getSelectors(
  (state: RootState) => state.sellerProfilesMunicipalities);
export default sellerProfilesMunicipalitiesSlice.reducer;
